/**
 * useScrollPosition - Custom hook for tracking scroll position with throttling
 * Optimized for performance with proper cleanup
 */

import { useState, useEffect, useRef } from 'react';

export const useScrollPosition = (threshold = 0) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const throttleRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      // Clear existing throttle
      if (throttleRef.current) {
        clearTimeout(throttleRef.current);
      }

      // Throttle scroll events for better performance
      throttleRef.current = setTimeout(() => {
        const scrollY = window.scrollY;
        setIsScrolled(scrollY >= threshold);
      }, 16); // ~60fps
    };

    // Initial check
    handleScroll();

    // Add event listener
    window.addEventListener('scroll', handleScroll, { passive: true });

    // Cleanup
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (throttleRef.current) {
        clearTimeout(throttleRef.current);
      }
    };
  }, [threshold]);

  return isScrolled;
};
